import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { BriefService } from "../../services/brief.service";

export function useGenerateBriefAIOverview() {
  const {
    mutate: generateBriefAiOverview,
    isSuccess: isGenerated,
    isError: isGenerateError,
    data,
  } = useMutation({
    mutationFn: ({
      briefId,
      brandId,
    }: {
      briefId: string;
      brandId: string;
    }) =>
      BriefService.generateBriefAiOverview({ briefId, brandId }).catch(
        async (err) => {
          const responseBody = await err.response.json();
          ToastService.error(responseBody.msg);
          throw err;
        }
      ),
    options: {
      skipInvalidation: true,
    },
  });

  return {
    generateBriefAiOverview,
    isGenerated,
    isGenerateError,
    data,
  };
}
